import React, { ReactElement, useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";

interface NavMenuProps {
  children?: ReactElement;
  title: string | ReactElement;
  handleClick?: () => void;
  section?: string;
  routes?: string[];
}
export const NavMenu = ({
  children,
  title,
  handleClick,
  section = "",
  routes = [],
}: NavMenuProps) => {
  const refMenu: any = useRef(null);
  const [actMenu, setActMenu] = useState("none");
  const history = useHistory();
  const [currentRoute, setCurrentRoute] = useState(history.location.pathname);

  const changeSection = useCallback(() => {
    if (handleClick) {
      handleClick();
    }
    setActMenu(section);
  }, [handleClick, section]);

  useEffect(() => {
    function handleClickOutside(e: any) {
      if (!refMenu.current.contains(e.target)) {
        setActMenu("none");
      } else {
        setTimeout(() => {
          setActMenu("none");
        }, 500);
      }
    }
    document.addEventListener("mousedown", handleClickOutside, true);
    document.addEventListener("scroll", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      document.removeEventListener("scroll", handleClickOutside, true);
    };
  }, [refMenu]);

  useEffect(() => {
    const unListen = history.listen(location => {
      setCurrentRoute(location.pathname);
    });
    return () => {
      unListen();
    };
  }, [history]);

  return (
    <div className={`flex flex-col justify-center items-center relative cursor-pointer`}>
      <div
        className={`flex w-full font-${
          routes?.length && !!routes.find(route => currentRoute.includes(route)) ? "semibold" : "normal"
        } text-[#2E3862] cursor-pointer`}
        onClick={changeSection}>
        {title}
      </div>
      <div ref={refMenu}>
        {actMenu === section && children && (
          <div
            id="dropdownNavbar"
            className="z-10 absolute left-0 top-[20px] bg-white divide-y divide-gray-100 rounded-lg shadow w-[257px]">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};
